import { render, staticRenderFns } from "./Diagram.vue?vue&type=template&id=250e0153&"
import script from "./Diagram.vue?vue&type=script&lang=js&"
export * from "./Diagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/max/WORK/vue-diagram-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('250e0153')) {
      api.createRecord('250e0153', component.options)
    } else {
      api.reload('250e0153', component.options)
    }
    module.hot.accept("./Diagram.vue?vue&type=template&id=250e0153&", function () {
      api.rerender('250e0153', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Diagram.vue"
export default component.exports